const { useEffect, useState } = require('react');

export default function useRenderOnlyClientSide() {
  let [shouldRender, setShouldRender] = useState(false);

  useEffect(() => setShouldRender(true), []);

  return shouldRender;
}
